export default __webpack_public_path__ + "static/media/lorenzXZ.28411e76.svg";